import React from 'react';
import type { MgaCrewLine, MgaPeriod } from '../useData';
import { PayslipDocument } from './PayslipDocument';

export type BulkPayslipsReportProps = {
  period: MgaPeriod;
  lines: MgaCrewLine[];
  companyLogoSrc?: string | null;
  companyLogoAlt?: string;
};

export const BulkPayslipsReport: React.FC<BulkPayslipsReportProps> = ({
  period,
  lines,
  companyLogoSrc = null,
  companyLogoAlt,
}) => {
  return (
    <div className="app-print-root mga-report-bulk">
      {lines.map((line, index) => (
        <PayslipDocument
          key={line.id}
          period={period}
          line={line}
          compact
          printRoot={false}
          companyLogoSrc={companyLogoSrc}
          companyLogoAlt={companyLogoAlt}
          pageNumber={index + 1}
          pageCount={lines.length}
          className={index < lines.length - 1 ? 'mga-report-page' : undefined}
        />
      ))}
    </div>
  );
};

export default BulkPayslipsReport;
